import { Injectable, Signal } from '@angular/core';
import { IFormContentData, IFormPreviewGroup, ISignatureData, ISignatureModel } from '@partners/api';
import { IRemoteError } from '@partners/errors';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { ISignatureState, SignatureActions, SignatureSelectors } from '../store';

@Injectable({
  providedIn: 'root'
})
export class SignatureStore extends StateAccessService<ISignatureState> {
  readonly state$: Observable<ISignatureState>;

  readonly data$$: Signal<ISignatureData>;
  readonly model$$: Signal<ISignatureModel>;

  readonly previewGroups$$: Signal<IFormPreviewGroup[]>;

  constructor() {
    super();

    this.model$$ = this.stateFacade.selectSignal$(SignatureSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(SignatureSelectors.data);
    this.previewGroups$$ = this.stateFacade.selectSignal$(SignatureSelectors.formPreviewGroups);
  }

  dispatchSignatureReset() {
    this.stateFacade.dispatch(SignatureActions.reset());
  }

  dispatchUpdateFormState() {
    this.stateFacade.dispatch(SignatureActions.updateFormStatus());
  }

  dispatchUpdateFormStateSuccess(groupPreview: IFormPreviewGroup) {
    this.stateFacade.dispatch(SignatureActions.updateFormStatusSuccess({ groupPreview }));
  }
  dispatchUpdateFormStateFailure(error: IRemoteError) {
    this.stateFacade.dispatch(SignatureActions.updateFormStatusFailure({ error }));
  }

  dispatchLoadFormsPreview() {
    this.stateFacade.dispatch(SignatureActions.loadFormsPreview());
  }
  dispatchSignatureLoadSuccess({ model, data }: { model: ISignatureModel; data: ISignatureData }) {
    this.stateFacade.dispatch(SignatureActions.loadFormsPreviewSuccess({ model, data }));
  }
  dispatchSignatureLoadFailure(error: IRemoteError) {
    this.stateFacade.dispatch(SignatureActions.loadFormsPreviewFailure({ error }));
  }

  dispatchFormContentLoad(fileId: number) {
    this.stateFacade.dispatch(SignatureActions.loadFormContent({ fileId }));
  }
  dispatchFormContentLoadSuccess(formContent: IFormContentData) {
    this.stateFacade.dispatch(SignatureActions.loadFormContentSuccess({ formContent }));
  }
  dispatchFormContentLoadFailure(error: IRemoteError) {
    this.stateFacade.dispatch(SignatureActions.loadFormsPreviewFailure({ error }));
  }
  dispatchSignatureSubmitSuccess({ data }: { data: ISignatureData }) {
    this.stateFacade.dispatch(SignatureActions.submitSuccess({ data }));
  }
}
